import * as signalR from "@microsoft/signalr";

export const Constants = {
    animationDuration: 180,
    webUrl: process.env.REACT_APP_WEB_URL ?? "",
    schoolsUrl: process.env.REACT_APP_SCHOOLS_URL ?? "",
    gtm: process.env.REACT_APP_GTM_FRANKENSTORIES ?? "",
    googleOauthClientId: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID ?? "",
    signalRLogLevel: signalR.LogLevel.Error,
    lessonTeachingWithFrankenstories: "https://writelike.org/lessons/teaching-with-frankenstories",
    instagramUrl: "https://www.instagram.com/frankenstories_game/",
    facebookUrl: "https://www.facebook.com/people/Frankenstories/100083185037954/",
    purchasingInfoForSchoolsAndDistricts: "/purchasing-information-for-schools-and-districts",
};
